import { Phone } from 'lucide-react'
import { FC, useCallback } from 'react'

import { Input } from '@/components/ui/input'

import { cleanPhoneNumber } from './phoneUtils'

interface PhoneInputProps {
  value?: string
  onChange: (value: string) => void
  placeholder?: string
  disabled?: boolean
  className?: string
}

export const PhoneInput: FC<PhoneInputProps> = ({
  value = '',
  onChange,
  placeholder = 'Número de teléfono',
  disabled = false,
  className = '',
}) => {
  // Handle phone number input with basic validation
  const handlePhoneChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const cleanValue = cleanPhoneNumber(e.target.value)
      onChange(cleanValue)
    },
    [onChange]
  )

  return (
    <div className="space-y-1">
      <div className="relative">
        <Phone className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <Input
          type="tel"
          placeholder={placeholder}
          className={`pl-10 ${className}`}
          value={value}
          onChange={handlePhoneChange}
          disabled={disabled}
        />
      </div>
    </div>
  )
}
